import { render, staticRenderFns } from "./ChatDock.vue?vue&type=template&id=36ae9ae2&scoped=true"
import script from "./ChatDock.vue?vue&type=script&lang=js"
export * from "./ChatDock.vue?vue&type=script&lang=js"
import style0 from "./ChatDock.vue?vue&type=style&index=0&id=36ae9ae2&prod&lang=css"
import style1 from "./ChatDock.vue?vue&type=style&index=1&id=36ae9ae2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ae9ae2",
  null
  
)

export default component.exports